// extracted by mini-css-extract-plugin
export default {"imgdiv":"_0c83a956f8 aa53bebd19","img":"_6393fe46f2 _59329998d7"};